export default "__VITE_ASSET__CZDONLpd__"